var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"mx-1",attrs:{"href":_vm.link.url},domProps:{"textContent":_vm._s(_vm.link.caption)}})}
var staticRenderFns = []

export { render, staticRenderFns }